import { RequestType } from '../../../core/types';
import { Channel } from '../types/channel';
import { SelectOption } from '../types/option';
import { PersonalDataFormValues } from '../types/personalDataForm';
import { SubmitRequestPayload } from '../types/submission';
import { resolveStoreTypeOptionId } from './resolveStoreTypeOptionId';

type BuildSubmitPayloadParams = {
  type: RequestType;
  personalData: PersonalDataFormValues;
  channel: Channel;
  branchId: string;
  themeId: string;
  description: string;
  files: File[];
  storeTypeOptions: SelectOption[];
};

/** Monta o payload de envio a partir dos valores dos formulários: resolve o `storeType` a partir do canal escolhido e omite `branch` para `loja_online`, que não tem filial a reportar. */
export function buildSubmitPayload(params: BuildSubmitPayloadParams): SubmitRequestPayload {
  const isPhysicalStore = params.channel !== 'loja_online';

  return {
    type: params.type,
    personalData: params.personalData,
    channel: params.channel,
    branch: isPhysicalStore ? params.branchId : undefined,
    storeType: resolveStoreTypeOptionId(params.storeTypeOptions, params.channel),
    themeId: params.themeId,
    description: params.description,
    files: params.files,
  };
}
